"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNodeRuleSet = createNodeRuleSet;
const shared_1 = require("@buildwithflux/shared");
const lodash_1 = require("lodash");
/** Boilerplate for converting a flat {rule: value} mapping to an PcbRulesMap */
function createNodeRuleSet(rules, useKeyAsUid = false) {
    // TODO is useKeyAsUid actually necessary? I've kept it for compatibility
    // with old code, but it seems like a potentially unwanted artifact.
    // ^ Further note on the above, for anyone investigating in future:
    // in some cases (eg generating virtual nodes from assets or stitching),
    // it is important that uids remain deterministic. Stitching does this
    // by generating its own uids; I think Asset footprint creation might
    // do it by using the key as uid. Getting it wrong could cause severe
    // perf impact, due to needless state changes. Update with care.
    let order = 0;
    return (0, lodash_1.mapValues)(rules, (v, k) => ({
        key: k,
        value: v,
        uid: useKeyAsUid ? k : (0, shared_1.guid)(),
        order: order++, // Is this used? Kept for compatibility; Javascript object key order preservation ensures the order remains as specified by the caller.
    }));
}
//# sourceMappingURL=factory.js.map